var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("LoadingSpinner")
    : _c(
        "div",
        { attrs: { id: "app" } },
        [
          _c("Auth"),
          _c("router-view"),
          _c("Modal"),
          _c("Footer"),
          _c("Notifications"),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }